import React from 'react'
import { Button, Dropdown } from 'antd'
import { DownloadOutlined, DownOutlined } from '@ant-design/icons'

const ExportDropdownButton = ({
    onExport,
    formats = ['csv', 'xlsx'],
    loading = false,
    buttonText = 'Export',
    size = 'small',
}) => {
    const handleExport = format => {
        onExport(format)
    }

    // If only one format, show simple button
    if (formats.length === 1) {
        return (
            <Button size={size} icon={<DownloadOutlined />} loading={loading} onClick={() => handleExport(formats[0])}>
                {buttonText}
            </Button>
        )
    }

    // Multiple formats, show dropdown
    const items = formats.map(format => ({
        key: format,
        label: format.toUpperCase(),
        onClick: () => handleExport(format),
    }))

    return (
        <Dropdown menu={{ items }} trigger={['click']} placement='bottomRight'>
            <Button size={size} icon={<DownloadOutlined />} loading={loading}>
                {buttonText} <DownOutlined />
            </Button>
        </Dropdown>
    )
}

export default ExportDropdownButton
